// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__21Wj3","overflowing":"ReadFullNote_overflowing__3AKf9"};